import { FormRenderProps, SimNaoEnum } from 'components/form'
import { AldeiaSelectFieldModel } from 'components/form/field/select/AldeiaSelectField'
import { BairroSelectFieldModel } from 'components/form/field/select/BairroSelectField'
import { CboSelectModel } from 'components/form/field/select/CboSelectField'
import { DseiSelectFieldModel } from 'components/form/field/select/DseiSelectField'
import { EscolaridadeSelectModel } from 'components/form/field/select/EscolaridadeSelectField'
import { EtniaSelectFieldModel } from 'components/form/field/select/EtniaSelectField'
import { FichaNotificacaoSelectModel } from 'components/form/field/select/FichasNotificacaoCasoSuspeitoSelectField'
import { LogradouroSelectModel } from 'components/form/field/select/LogradouroSelectField'
import { MunicipioSelectModel } from 'components/form/field/select/MunicipioSelectField'
import { PaisSelectFieldModel } from 'components/form/field/select/PaisSelectField'
import { PoloBaseSelectFieldModel } from 'components/form/field/select/PoloBaseSelectField'
import { RacaCorSelectModel } from 'components/form/field/select/RacaCorSelectField'
import { UfSelectModel } from 'components/form/field/select/UfSelectField'
import {
  DeficienciaEnum,
  IdentidadeGeneroEnum,
  JustificativaNaoPossuiCpfEnum,
  NacionalidadeEnum,
  OrientacaoSexualEnum,
  PovoComunidadeTradicionalEnum,
  SexoEnum,
} from 'graphql/types.generated'
import { ReactNode } from 'react'
import { metaPath } from 'util/metaPath'
import { ValidatorFunction } from 'util/validation'

export enum GestanteNotificacaoEnum {
  NAO = 'NAO',
  NAO_SE_APLICA = 'NAO_SE_APLICA',
  PRIMEIRO_TRIMESTRE = 'PRIMEIRO_TRIMESTRE',
  SEGUNDO_TRIMESTRE = 'SEGUNDO_TRIMESTRE',
  TERCEIRO_TRIMESTRE = 'TERCEIRO_TRIMESTRE',
  IDADE_GESTACIONAL_IGNORADA = 'IDADE_GESTACIONAL_IGNORADA',
}

export const gestanteNotificacaoRecord: Record<GestanteNotificacaoEnum, string> = {
  NAO: 'Não',
  NAO_SE_APLICA: 'Não se aplica',
  IDADE_GESTACIONAL_IGNORADA: 'Idade gestacional ignorada',
  PRIMEIRO_TRIMESTRE: '1º trimestre',
  SEGUNDO_TRIMESTRE: '2º trimestre',
  TERCEIRO_TRIMESTRE: '3º trimestre',
}

export const NOME_MAX_LENGTH = 70

export interface DadosIdentificacaoFormModel {
  dataNotificacao?: LocalDate
  nome?: string
  nomeSocial?: string
  cpf?: string
  stNaoPossuiCpf?: boolean
  cns?: string
  justificativaNaoPossuiCpf?: JustificativaNaoPossuiCpfEnum
  dataNascimento?: LocalDate
  sexo?: SexoEnum
  nacionalidade?: NacionalidadeEnum
  paisNascimento?: PaisSelectFieldModel
  municipioNascimento?: MunicipioSelectModel
  racaCor?: RacaCorSelectModel
  isCidadaoAldeado?: SimNaoEnum
  dsei?: DseiSelectFieldModel
  etnia?: EtniaSelectFieldModel
  poloBase?: PoloBaseSelectFieldModel
  aldeia?: AldeiaSelectFieldModel
  nomePai?: string
  desconheceNomePai?: boolean
  nomeMae?: string
  desconheceNomeMae?: boolean
  identidadeGenero?: IdentidadeGeneroEnum
  orientacaoSexual?: OrientacaoSexualEnum
  isMembroComunidadeTradicional?: SimNaoEnum
  povoComunidadeTradicional?: PovoComunidadeTradicionalEnum
  gestante?: GestanteNotificacaoEnum
}

export enum ZonaNotificacaoEnum {
  URBANA = 'URBANA',
  RURAL = 'RURAL',
  PERIURBANA = 'PERIURBANA',
  IGNORADO = 'IGNORADO',
}

export const zonaNotificacaoRecord: Record<ZonaNotificacaoEnum, string> = {
  URBANA: 'Urbana',
  RURAL: 'Rural',
  PERIURBANA: 'Periurbana',
  IGNORADO: 'Ignorado',
}

export interface EnderecoResidenciaFormModel {
  /** Sem fonte de dados no PEC — ver TODO no EnderecoResidenciaSection. */
  regiaoAdministrativa?: string
  cep?: string
  uf?: UfSelectModel
  logradouro?: LogradouroSelectModel
  numero?: string
  semNumero?: boolean
  complemento?: string
  bairro?: BairroSelectFieldModel
  municipio?: MunicipioSelectModel
  zona?: ZonaNotificacaoEnum
  pais?: PaisSelectFieldModel
}

export interface DadosIndividuoFormModel {
  escolaridade?: EscolaridadeSelectModel
  ocupacao?: CboSelectModel
  /** Sem fonte de dados no PEC — ver TODO no DadosIndividuoStep. */
  atividadeEconomicaCnae?: string
  isProfissionalSaude?: SimNaoEnum
  possuiDeficiencia?: SimNaoEnum
  deficiencia?: DeficienciaEnum
  endereco?: EnderecoResidenciaFormModel
  isPessoaSituacaoRua?: SimNaoEnum
  isPessoaPrivadaLiberdade?: SimNaoEnum
  telefone?: string
}

export interface Cid10NotificacaoAgravoModel {
  id: ID
  nome: string
  codigo: string
}

export interface DadosClinicosFormModel {
  agravosSuspeitos?: ReadonlyArray<FichaNotificacaoSelectModel>
  agravosConfirmados?: ReadonlyArray<FichaNotificacaoSelectModel>
  /** Sem fonte de dados no PEC (tabela MedDRA) — ver TODO no DadosClinicosStep. */
  sinaisSintomas?: ReadonlyArray<string>
  outrosSinaisSintomas?: string
  dataInicioSintomas?: LocalDate
  dataDiagnostico?: LocalDate
  dataAtendimento?: LocalDate
  isDoencaRelacionadaTrabalho?: SimNaoEnum
  isDoencaRelacionadaDesastre?: SimNaoEnum
}

export interface IdNomeNotificacaoModel {
  id: ID
  nome: string
}

export interface NotificacaoFormModel {
  unidadeSaude?: IdNomeNotificacaoModel
  municipio?: IdNomeNotificacaoModel
  uf?: IdNomeNotificacaoModel
}

export interface NotificacaoAgravoFormModel {
  dadosIdentificacao?: DadosIdentificacaoFormModel
  dadosIndividuo?: DadosIndividuoFormModel
  dadosClinicos?: DadosClinicosFormModel
  notificacao?: NotificacaoFormModel
}

export interface NotificacaoAgravoStep {
  title: string
  render: (formProps: FormRenderProps<NotificacaoAgravoFormModel>) => ReactNode
  validator?: ValidatorFunction<NotificacaoAgravoFormModel>
}

export const metaNotificacaoAgravo = metaPath<NotificacaoAgravoFormModel>()
